<template>
<div class="chapter">
<div class="inner_page">
<a id="pageiii">
<h1 class="titlepage">The Battle of Fontenoy 1745</h1>
<h1 class="titlepage1">Saxe against Cumberland in the War of the Austrian Succession</h1>
<h1 class="titlepage2">James Falkner</h1>
<p class="logo"><img alt="image" src="images/logo.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Titlepage.vue?682fb0a4